import {
  FETCH_SHIPPING_TYPES,
  FETCH_SHIPPING_TYPE,
  CREATE_SHIPPING_TYPES,
  EDIT_SHIPPING_TYPES,
  DELETE_SHIPPING_TYPES
} from '../actions/types'

const shippingTypesReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_SHIPPING_TYPES:
      return action.payload
    case FETCH_SHIPPING_TYPE:
      return [...state.filter(type => type.id !== action.payload.id), action.payload]
    case CREATE_SHIPPING_TYPES:
      return [...state, action.payload]
    case EDIT_SHIPPING_TYPES:
      return state.map(type => (type.id === action.payload.id ? action.payload : type))
    case DELETE_SHIPPING_TYPES:
      return state.filter(preset => preset.id !== action.payload.id)
    default:
      return state
  }
}

export default shippingTypesReducer
